import React from "react";

export const ActiveOrdersSkeleton: React.FC<{ count?: number }> = ({
  count = 5,
}) => {
  return (

      <div>
         <div className=" w-60 rounded-2xl h-3 mb-2 bg-slate-200 animate-pulse"/>
        {Array.from({ length: count }).map((_, i) => (
          <div
            key={i}
            className="rounded-2xl border border-slate-100 bg-white p-3 mb-4"
          >
            
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="h-2 w-2 rounded-full bg-slate-200 animate-pulse" />
                <div className="h-3 w-44 rounded bg-slate-200 animate-pulse" />
              </div>
              <div className="h-3 w-12 rounded bg-slate-200 animate-pulse" />
            </div>

            {/* Контент */}
            <div className="mt-3 flex items-center gap-3">
              {/* Иконка */}
              <div className="h-10 w-10 rounded-full bg-slate-200 animate-pulse" />

              {/* Тексты */}
              <div className="flex-1 min-w-0">
                <div className="h-4 w-32 rounded bg-slate-200 animate-pulse" />
                <div className="mt-2 h-3 w-20 rounded bg-slate-200 animate-pulse" />
              </div>

              {/* Цена + кнопка */}
              <div className="flex flex-col items-end gap-2">
                <div className="h-4 w-14 rounded bg-slate-200 animate-pulse" />
                <div className="h-3 w-14 rounded bg-slate-200 animate-pulse" />
              </div>
            </div>
          </div>
        ))}
      </div>
  );
};
